import { inject } from '@angular/core';

import {
  injectTellentAppKind,
  ORG_GUID,
  TellentClientOneDomainLegacyRedirect,
  TellentPageConfig,
} from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';

export function redirectToOneDomainIfLegacyDomainVisited(
  isOneDomainEnabled: boolean,
  oneDomainUrl: string,
  preservePath: boolean = false,
) {
  if (!isOneDomainEnabled) {
    return false;
  }

  const isOneDomainHost = oneDomainUrl.includes(window.location.hostname);

  if (isOneDomainHost) {
    return false;
  }

  const urlBuilder = injectTellentAppUrlBuilder();
  const appKind = injectTellentAppKind();
  const orgGuid = inject(ORG_GUID)!;

  const redirectConfig = preservePath
    ? <TellentPageConfig<typeof TellentClientOneDomainLegacyRedirect>>{
        id: TellentClientOneDomainLegacyRedirect,
        params: { path: window.location.href.replace(window.location.origin, 'tellent://') },
      }
    : undefined;

  const redirectUrl = urlBuilder(appKind, redirectConfig, orgGuid);

  window.open(redirectUrl, '_self');

  return true;
}
